import { Button } from '@progress/kendo-react-buttons'
import { DateRangePicker } from '@progress/kendo-react-dateinputs'
import { Grid, GridColumn, GridSortChangeEvent } from '@progress/kendo-react-grid'
import over from 'lodash/fp/over'
import pipe from 'lodash/fp/pipe'
import prop from 'lodash/fp/prop'
import isNil from 'lodash/isNil'
import moment from 'moment'
import * as React from 'react'
import { connect } from 'react-redux'
import * as ReactStrap from 'reactstrap'
import * as Redux from 'redux'
import * as App from '../../app/types'
import * as Breadcrumb from '../../components/breadcrumbs'
import { FlashMessage } from '../../components/flash-message'
import * as ImageUpload from '../../components/image-upload'
import * as IsActive from '../../components/is_active'
import * as Link from '../../components/link'
import { Loading } from '../../components/loading'
import * as Menu from '../../components/menu/left-nav'
import * as RasaModal from '../../components/modal'
import * as RasaInput from '../../components/rasa-input'
import * as Sortable from '../../components/sortable'
import * as Request from '../../request'
import * as CommunityConfig from '../community-config'
import * as GridCell from '../grid-cell'
import * as Reference from '../reference'
import * as Actions from './actions'
import {FETCH_PROMOTIONS} from './constants'
import * as Render from './render'
import './styles.css'
import * as Types from './types'
import * as Utils from './utils'

const breadcrumbs: Breadcrumb.Breadcrumbs = Menu.breadcrumbs(Menu.CONTENT_PROMOTIONS_URL)

interface SubmitProps {
  resetModal: RasaModal.Reset,
  submitModal: RasaModal.Submit<Types.ModalData>
  updateDate: any, // TODO: I am so sick of writing types right now. Please forgive me.
}
interface AppProps {
  app: App.State
  communityConfig: CommunityConfig.State,
  promotions: Types.FullComponentState,
  referenceData: Reference.ReferenceState,
}

const PromotionsTemplates = ({data}: {data: string[]}) => <div>
  {data.length > 0 ?
    <div>
      Your current template supports these promotions:
      <ul>
        {data.map((s: string) => <li key={s}>{s}</li>)}
      </ul>
    </div>
  : <div>Your current template does not support promotions.</div>}
</div>

interface UploadImageProps {
  uploadImage: any;
}
type ModalProps = RasaModal.DispatchState &
                  SubmitProps & AppProps & UploadImageProps

export const PromotionsModal = ({
  app, referenceData, promotions, communityConfig, resetModal, submitModal, showModal, updateDate, updateModal,
  uploadImage,
}: ModalProps) =>
<ReactStrap.Modal className="modal-lg" isOpen={promotions.modal.isOpen}>
  <form className="k-form promotions" onSubmit={Link.preventDefault()}>
    <ReactStrap.ModalHeader toggle={showModal}>{promotions.modal.data.id ? 'Edit Promotion' : 'Add Promotion'}
    </ReactStrap.ModalHeader>
    <ReactStrap.ModalBody>
      <ReactStrap.Row>
        <div className="modal-row">
          <RasaInput.RasaInput label="URL"
                            placeholder=""
                            value={promotions.modal.data.target_url}
                            validation={RasaInput.validateForgivingUrl(promotions.modal.data.target_url)}
                            onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                            updateModal({name: 'target_url', value: e.target.value})} />
        </div>
      </ReactStrap.Row>
      <ReactStrap.Row>
        <div className="modal-row">
          <ImageUpload.ImageUpload imageUrl={promotions.modal.data.image_url}
            fieldChangeAction={(fieldValue: string) => updateModal({name: 'image_url', value: fieldValue})}
          />
        </div>
      </ReactStrap.Row>
      <ReactStrap.Row>
        <div className="modal-row-container">
          <div className="modal-col-1">
            <RasaInput.RasaInput label="Title"
                              placeholder=""
                              value={promotions.modal.data.title}
                              validation={RasaInput.validateTitle(promotions.modal.data.title)}
                              onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                                updateModal({name: 'title', value: e.target.value})} />
          </div>
          <div className="modal-col-2">
            <RasaInput.RasaNumericInput label="Rank"
                                value={promotions.modal.data.rank}
                                onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                                  updateModal({name: 'rank', value: e.target.value})} />
          </div>
        </div>
      </ReactStrap.Row>
      <ReactStrap.Row>
        <ReactStrap.Col sm="6">
          <ReactStrap.Row>
            <div className="field">
              <ReactStrap.Label className="field-label">
                Date Range
                {!Utils.dateRangeValid(promotions.modal.data) &&
                  <i className={`fa fa-exclamation-triangle icon-error ${RasaInput.hideOnMobile}`}
                     aria-hidden="true"></i>}
              </ReactStrap.Label>
              <DateRangePicker
                value={{
                  end: isNil(promotions.modal.data.end_date) ? null : promotions.modal.data.end_date.toDate(),
                  start: isNil(promotions.modal.data.start_date) ? null : promotions.modal.data.start_date.toDate(),
                }}
                onChange={updateDate}
              />
            </div>
          </ReactStrap.Row>
          <ReactStrap.Row>
            <RasaInput.RasaSelectInput
                label="Type"
                onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                  updateModal({name: 'promotion_type_id', value: e.target.value})}
                options={Utils.asModalDropdown(promotions.modal.data.promotion_type_id, referenceData.promotion_types)}
                validation={Utils.validateSelectedPromotion(
                  promotions.modal.data.promotion_type_id,
                  referenceData.templates,
                  communityConfig.gridState)}
                value={promotions.modal.data.promotion_type_id}
              />
          </ReactStrap.Row>
        </ReactStrap.Col>
        <ReactStrap.Col sm="6">
          <PromotionsTemplates data={Utils.templatePromotions(referenceData.templates, communityConfig.gridState)}/>
        </ReactStrap.Col>
      </ReactStrap.Row>
      <ReactStrap.Row className="collapse-container">
        <RasaInput.RasaCollapse label="Ad Server Integration" labelstyle="collapsable-sub-section-header">
          <ReactStrap.Row className="row-borders">
            <ReactStrap.Col sm="12">
              <ReactStrap.Row>
                <ReactStrap.Col md="4" lg="4">
                  <RasaInput.RasaInput label="Customer Identifier"
                                placeholder=""
                                helpType="promotion-person-parameter"
                                value={promotions.modal.data.person_parameter}
                                onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                                  updateModal({name: 'person_parameter', value: e.target.value})} />
                </ReactStrap.Col>
                <ReactStrap.Col md="4" lg="4">
                  <RasaInput.RasaInput label="Date"
                                placeholder=""
                                helpType="promotion-date-parameter"
                                value={promotions.modal.data.date_parameter}
                                onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                                  updateModal({name: 'date_parameter', value: e.target.value})} />
                </ReactStrap.Col>
                <ReactStrap.Col md="4" lg="4">
                  <RasaInput.RasaInput label="Message Identifier"
                                placeholder=""
                                helpType="promotion-token-parameter"
                                value={promotions.modal.data.token_parameter}
                                onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                                updateModal({name: 'token_parameter', value: e.target.value})} />
                </ReactStrap.Col>
              </ReactStrap.Row>
              <ReactStrap.Row>
                <ReactStrap.Col md="4" lg="4">
                  <RasaInput.RasaInput label="Email Address"
                                placeholder=""
                                helpType="promotion-email-parameter"
                                value={promotions.modal.data.email_parameter}
                                onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                                  updateModal({name: 'email_parameter', value: e.target.value})} />
                </ReactStrap.Col>
                <ReactStrap.Col md="4" lg="4">
                  <RasaInput.RasaInput label="Email Address - MD5"
                                placeholder=""
                                helpType="promotion-emailhash-parameter"
                                value={promotions.modal.data.emailhash_parameter}
                                onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                                  updateModal({name: 'emailhash_parameter', value: e.target.value})} />
                </ReactStrap.Col>
              </ReactStrap.Row>
            </ReactStrap.Col>
          </ReactStrap.Row>
        </RasaInput.RasaCollapse>
      </ReactStrap.Row>
    </ReactStrap.ModalBody>
    <ReactStrap.ModalFooter>
      {promotions.modal.isSubmitting ? <Loading size={Loading.Sizes.SMALL} /> : <span/>}
      <ReactStrap.Button color="primary"
              disabled={promotions.modal.isSubmitting || !Utils.modalStateValid(promotions.modal.data)}
              onClick={() => submitModal(app.selectedCommunity, promotions.modal.data)}>
        Save
      </ReactStrap.Button>
      <ReactStrap.Button onClick={showModal}>Cancel</ReactStrap.Button>
      <ReactStrap.Button onClick={resetModal}>Clear</ReactStrap.Button>
    </ReactStrap.ModalFooter>
  </form>
</ReactStrap.Modal>

export const PromotionsModalConnect = connect(
  ({app, promotions, referenceData, communityConfig}: AppProps) =>
    ({app, promotions, referenceData, communityConfig}),
  {
    resetModal: Actions.resetModal,
    showModal: Actions.toggleModal,
    submitModal: Actions.createOrUpdate,
    updateModal: Actions.updateModalField,
    uploadImage: Actions.uploadImage,
  },
  (stateProps, dispatchProps, ownProps) => ({
    ...stateProps,
    ...dispatchProps,
    ...ownProps,
    updateDate: pipe(
      prop('target.value'),
      over([
        (date) => dispatchProps.updateModal({
          name: 'start_date',
          value: date.start ? moment(date.start) : null,
        }),
        (date) => dispatchProps.updateModal({
          name: 'end_date',
          value: date.end ? moment(date.end) : null,
        }),
      ]),
    ),
  }),
)(PromotionsModal)

interface HeaderProps {
  showModal: RasaModal.Toggle,
}

const AddPromotion = ({view, showModal}: Types.WrappedViewState & HeaderProps) => <Button
  disabled={view.isLoading}
  className="secondary-button"
  onClick={showModal}
  title="Add Promotion">
  Add
</Button>

export const AddPromotionConnected = connect(
  ({promotions}: Types.WrappedState) => ({view: promotions.view}),
  {showModal: Actions.toggleModal},
)(AddPromotion)

const PromotionsHeader = ({view}: Types.WrappedViewState) => <div>
  <FlashMessage />
  <Breadcrumb.BreadcrumbComponent breadcrumbs={breadcrumbs}/>
  <ReactStrap.Row className="margin-auto">
    <ReactStrap.Col sm="12" md="10" className="text-left page-header--padding">
      <div className="page-header">
        <span className="title">Promotions</span>
        <AddPromotionConnected />
      </div>
    </ReactStrap.Col>
    <ReactStrap.Col sm="12" md="2">
      <div className="page-header--padding">
        <IsActive.FilterSelect view={view} event={FETCH_PROMOTIONS} disabled={view.isLoading}/>
      </div>
    </ReactStrap.Col>
  </ReactStrap.Row>
</div>

interface DispatchProps {
  dispatch: Redux.Dispatch<Redux.Action>
}

type Props = Types.WrappedState & DispatchProps

export const PromotionsGrid = ({promotions, dispatch}: Props) =>
<div>
{ promotions.view.isLoading ?
  <Loading center size={Loading.Sizes.LARGE} />
:
  <div>
    <ReactStrap.Row>
      <ReactStrap.Col>
        <Grid data={Request.withDispatch(promotions.data, dispatch)}
              sortable={{
                allowUnsort: true,
                mode: 'multiple',
              }}
              sort={promotions.view.sort}
              onSortChange={(e: GridSortChangeEvent) => dispatch({
                                    options: { value: e.sort },
                                    type: Sortable.sortTableConstant(FETCH_PROMOTIONS),
              })}>
          <GridColumn cell={Render.ActiveCell} field="is_active" title="Active" />
          <GridColumn field="target_url" title="URL"/>
          <GridColumn field="title" title="Title"/>
          <GridColumn field="description" title="Type" />
          <GridColumn field="rank" title="Rank" />
          <GridColumn cell={GridCell.ImageCell} field="preview_image_url" title="Image" sortable={false}/>
          <GridColumn cell={GridCell.DateCell} field="start_datetime" title="Start"/>
          <GridColumn cell={GridCell.DateCell} field="end_datetime" title="Ends"/>
          <GridColumn cell={GridCell.DateTimeCell} field="created_datetime" title="Created"/>
          <GridColumn cell={Render.EditCell} />
        </Grid>
      </ReactStrap.Col>
    </ReactStrap.Row>
    <PromotionsModalConnect />
  </div>}
</div>

export const PromotionsGridConnected = connect(
  ({promotions}: Types.WrappedState) => ({promotions}),
  (dispatch) => ({dispatch}),
)(PromotionsGrid)

export const PromotionsView = ({promotions}: Types.WrappedState) => <div>
  <ReactStrap.Row>
    <ReactStrap.Col>
      <PromotionsHeader view={promotions.view}/>
    </ReactStrap.Col>
  </ReactStrap.Row>
  <PromotionsGridConnected />
</div>

export const PromotionsViewConnected = connect(
  ({promotions}: Types.WrappedState) => ({promotions}),
)(PromotionsView)



// WEBPACK FOOTER //
// ./src/pages/promotions/component.tsx